import { Component, OnInit } from '@angular/core';
import { RPCMachineDeviceCompatibilityFilter, RPCMachineDeviceCompatibilityFilterItemsResponse } from '../../../remote-price-change/remote-price-change-service/remote-price-change.model';
import { FilterBarService } from '../../filter-bar-service/filter-bar.service';
import { ISubscription } from 'rxjs-compat/Subscription';

@Component({
  selector: 'app-rpc-compatibility-filters',
  templateUrl: './rpc-compatibility-filters.component.html',
  styleUrls: ['./rpc-compatibility-filters.component.scss']
})
export class RpcCompatibilityFiltersComponent implements OnInit {
  vendorCodesDropdown: string[] = [];
  machineModelsDropDown: string[] = [];

  selectedVendorCodes: string[] = [];
  selectedMachineModels: string[] = [];
  selectedMachineActions: string[] = [];
  selectAllMachineActions: boolean = true;
  selectAllVendorCodes: boolean = true;
  selectAllMachineModels: boolean = true;
  machineActionsDropdown: { label: string, value: string }[] = [];
  private machineActionOrder: { value: string, label: string }[] = [
    { value: 'FirmwareActions', label: 'Firmware Actions' },
    { value: 'PasscodeActions', label: 'Passcode Actions' },
    { value: 'DEXDataMissing', label: 'DEX Data Missing' },
    { value: 'MultipleDevices', label: 'Multiple Devices' },
    { value: 'MissingPOGSelectionOnDex', label: 'Missing POG Selection On DEX' },
    { value: 'NoIssue', label: 'No Issue' }
  ];
  deviceNoSearch: string;
  filterItem:RPCMachineDeviceCompatibilityFilter;
  latestDEXDateTime: any;
  
  constructor(private _filter: FilterBarService) { }

  ngOnInit() {
    this.vendorCodesDropdown = new Array();
    this.filterItem = new RPCMachineDeviceCompatibilityFilter();

    this._filter.GetRPCMachineDeviceCompatibilityFilterData().subscribe((data: RPCMachineDeviceCompatibilityFilterItemsResponse) => {
      this.fillDropdowns(data);
    });

    this._filter.resetFilters.subscribe(data => {
      this.performReset();
    });
  }

  private fillDropdowns(data: RPCMachineDeviceCompatibilityFilterItemsResponse) {
    data.vendors.forEach(y => {
      this.vendorCodesDropdown.push(y.vendorCode);
    });

    data.machineModels.forEach(y => {
      this.machineModelsDropDown.push(y.machineModelNumber);
    });

    if (data.machineActions) {
      const apiKeys = new Set(data.machineActions.map(a => a.machineActionName));
      const ordered = this.machineActionOrder.filter(a => apiKeys.has(a.value));
      const unknown = data.machineActions
        .filter(a => !this.machineActionOrder.some(o => o.value === a.machineActionName))
        .map(a => ({ value: a.machineActionName, label: a.machineActionName }));
      this.machineActionsDropdown = [...ordered, ...unknown];
    }

    this.filterItem.messages = data.messages || [];

    this.selectAllDefaults();
  }

  private selectAllDefaults() {
    this.selectedMachineActions = this.machineActionsDropdown.map(a => a.value);
    this.selectedVendorCodes = [...this.vendorCodesDropdown];
    this.selectedMachineModels = [...this.machineModelsDropDown];
    this.selectAllMachineActions = true;
    this.selectAllVendorCodes = true;
    this.selectAllMachineModels = true;

    this.filterItem.machineActions = null;
    this.filterItem.vendorCodes = null;
    this.filterItem.machineModels = null;
    this._filter.updateRpcCompatibilityFilter(this.filterItem);
  }

  toggleSelectAllMachineActions() {
    this.selectedMachineActions = this.selectAllMachineActions ? this.machineActionsDropdown.map(a => a.value) : [];
    this.filterItem.machineActions = this.selectAllMachineActions ? null : null;
    this._filter.updateRpcCompatibilityFilter(this.filterItem);
  }

  toggleMachineAction(value: string) {
    if (!this.selectedMachineActions) {
      this.selectedMachineActions = [];
    }
    const index = this.selectedMachineActions.indexOf(value);
    if (index === -1) {
      this.selectedMachineActions.push(value);
    } else {
      this.selectedMachineActions.splice(index, 1);
    }
    this.selectAllMachineActions = this.selectedMachineActions.length === this.machineActionsDropdown.length;
    this.filterItem.machineActions = this.selectAllMachineActions ? null : (this.selectedMachineActions.length ? this.selectedMachineActions.join(',') : null);
    this._filter.updateRpcCompatibilityFilter(this.filterItem);
  }

  toggleSelectAllVendorCodes() {
    this.selectedVendorCodes = this.selectAllVendorCodes ? [...this.vendorCodesDropdown] : [];
    this.changeVendorCode();
  }

  toggleVendorCode(vendorCode: string) {
    if (!this.selectedVendorCodes) {
      this.selectedVendorCodes = [];
    }
    
    const index = this.selectedVendorCodes.indexOf(vendorCode);
    if (index === -1) {
      this.selectedVendorCodes.push(vendorCode);
    } else {
      this.selectedVendorCodes.splice(index, 1);
    }
    this.selectAllVendorCodes = this.selectedVendorCodes.length === this.vendorCodesDropdown.length;
    this.changeVendorCode();
  }

  changeVendorCode() {
    this.filterItem.vendorCodes = this.selectAllVendorCodes ? null : (this.selectedVendorCodes.length ? this.selectedVendorCodes.join(',') : null);
    this._filter.updateRpcCompatibilityFilter(this.filterItem);
  }

  toggleSelectAllMachineModels() {
    this.selectedMachineModels = this.selectAllMachineModels ? [...this.machineModelsDropDown] : [];
    this.changeMachineModels();
  }

  toggleMachineModel(machineModel: string) {
    if (!this.selectedMachineModels) {
      this.selectedMachineModels = [];
    }
    
    const index = this.selectedMachineModels.indexOf(machineModel);
    if (index === -1) {
      this.selectedMachineModels.push(machineModel);
    } else {
      this.selectedMachineModels.splice(index, 1);
    }
    this.selectAllMachineModels = this.selectedMachineModels.length === this.machineModelsDropDown.length;
    this.changeMachineModels();
  }

  changeMachineModels() {
    this.filterItem.machineModels = this.selectAllMachineModels ? null : (this.selectedMachineModels.length ? this.selectedMachineModels.join(', ') : null);
    this._filter.updateRpcCompatibilityFilter(this.filterItem);
  }

  showDateError() {
    return '';
  }

  showVendorCodeError() {
  }

  updateRPCCompatibilitySearch(rpcCompatibility: string) {
    const boolValue = rpcCompatibility === 'RPC_COMPATIBLE_ON'  ? true  : 
                      rpcCompatibility === 'RPC_COMPATIBLE_OFF' ? false : null;
    this.filterItem.rpcCompatibleInd = boolValue;
    this._filter.updateRpcCompatibilityFilter(this.filterItem);
  }

  updateDeviceNoFilter(deviceNo: string) {
    this.filterItem.deviceNo = deviceNo;
    this._filter.updateRpcCompatibilityFilter(this.filterItem);
  }  

  updateLatestDEXDateTimeFilter($event) {
    this.filterItem.dexSinceDateTime = $event;
    this._filter.updateRpcCompatibilityFilter(this.filterItem);
  }

  performReset() {
    const rpcCompatibility = document.getElementById("rpcCompatibileDropDown") as HTMLSelectElement;
    if (rpcCompatibility){
      rpcCompatibility.selectedIndex = 0;
    }
    
    this.deviceNoSearch = null;
    this.latestDEXDateTime = null;

    this.filterItem.rpcCompatibleInd = null;
    this.filterItem.deviceNo = null;
    this.filterItem.dexSinceDateTime = null;

    this.selectAllDefaults();
  }
}
